import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[appNumericOnly]',
    standalone: false
})
export class NumericOnlyDirective {
    el = inject(ElementRef);
    constructor() { }

    @HostListener('input', ['$event']) onInputChange(event: Event) {
        let nativeElement = this.el.nativeElement as HTMLInputElement;
        if (nativeElement.tagName != 'input') {
            nativeElement = nativeElement.querySelector('input') as HTMLInputElement;
        }

        if (nativeElement) {
            const initalValue = nativeElement.value;
            nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
            if (initalValue !== nativeElement.value) {
                event.stopPropagation();
            }
        }

    }

}

@Directive({
    selector: '[appAlphaNumeric]',
    standalone: false
})
export class AlphaNumericOnlyDirective {
    el = inject(ElementRef);

    constructor() { }

    @HostListener('input', ['$event']) onInputChange(event: Event) {
        let nativeElement = this.el.nativeElement as HTMLInputElement;
        if (nativeElement.tagName != 'input') {
            nativeElement = nativeElement.querySelector('input') as HTMLInputElement;
        }

        if (nativeElement) {
            const initalValue = nativeElement.value;
            nativeElement.value = initalValue.replace(/[^a-zA-Z0-9]*/g, '');
            if (initalValue !== nativeElement.value) {
                event.stopPropagation();
            }
        }

    }

}